import React from 'react'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

import NotificationModal from 'views/modals/notification_modal'

import paywallImage from 'assets/confirms/paywall-icon.svg'

const MyLibraryPaywallExpiredConfirm = props => (
	<NotificationModal
		alertTitle={localize('login_notification_extended_features_expired_title')}
		btnOne={localize('action_button_upgrade_now')}
		alertMessage={localize('login_notification_extended_features_expired')}
		buttonDismissText={localize('action_button_nothanks')}
		actionOne={props.actions.upgradePaywallExpired}
		closeAction={props.actions.closePaywallExpired}
		buttonDismissAction={props.actions.closePaywallExpired}
		imgIcon={paywallImage}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		upgradePaywallExpired: myLibraryActions.upgradePaywallExpired,
		closePaywallExpired: myLibraryActions.closePaywallExpired,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryPaywallExpiredConfirm)

export { MyLibraryPaywallExpiredConfirm }
